import * as api from "./client";
import type {
  CreateQuestionBody,
  LibraryQuestion,
  ListQuestionsParams,
  UpdateQuestionBody,
} from "./survey-library.service";

type ListQuestionsResponse = {
  questions: LibraryQuestion[];
  total: number;
  limit: number;
  offset: number;
  requestId: string;
};

type SingleQuestionResponse = {
  question: LibraryQuestion;
  requestId: string;
};

type DeleteQuestionResponse = {
  message: string;
  requestId: string;
};

export const randomLibrary = {
  list: async (params?: ListQuestionsParams): Promise<ListQuestionsResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.search) searchParams.append("search", params.search);
    if (params?.type) searchParams.append("type", params.type);
    if (params?.limit !== undefined) searchParams.append("limit", params.limit.toString());
    if (params?.offset !== undefined) searchParams.append("offset", params.offset.toString());

    const query = searchParams.toString() ? `?${searchParams.toString()}` : "";
    return api.get<ListQuestionsResponse>(`/v1/survey/random-library${query}`);
  },

  getById: async (id: string): Promise<SingleQuestionResponse> => {
    return api.get<SingleQuestionResponse>(`/v1/survey/random-library/${id}`);
  },

  create: async (data: CreateQuestionBody): Promise<SingleQuestionResponse> => {
    return api.post<SingleQuestionResponse>("/v1/survey/random-library", data);
  },

  update: async (id: string, data: UpdateQuestionBody): Promise<SingleQuestionResponse> => {
    return api.put<SingleQuestionResponse>(`/v1/survey/random-library/${id}`, data);
  },

  remove: async (id: string): Promise<DeleteQuestionResponse> => {
    return api.del<DeleteQuestionResponse>(`/v1/survey/random-library/${id}`);
  },

  /** survey-api caps `limit` at 100 — paginate until all random questions are loaded. */
  listAll: async (): Promise<LibraryQuestion[]> => {
    const pageSize = 100;
    const all: LibraryQuestion[] = [];
    let offset = 0;
    let total = 0;

    do {
      const page = await randomLibrary.list({ limit: pageSize, offset });
      total = page.total;
      all.push(...page.questions);
      offset += page.questions.length;
      if (page.questions.length === 0) {
        break;
      }
    } while (all.length < total);

    return all;
  },
};
